import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import BaseController from "../../common/base/BaseController";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtModal from "../../components/NtModal";
import {
  asyncStorageSetData,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import { fetchVoicemailBox } from "../../api/voicemail";
import voicemailcsvcolumndata from "../data/voicemailcsvcolumndata";
import settings from "../../config/settings";
import routes from "../../navigation/routes";
import NtVoicemailItemItem from "../components/NtVoicemailItem";
import NtVoicemailNewForm from "../components/NtVoicemailNewForm";

class VoicemailController extends BaseController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    searchFilter: null,
    page: 1,
  };

  column_location = "@voicemail_column_storage";
  addModalRef = React.createRef();

  componentDidMount() {
    this.handleDefaultColumnsFetch(
      this.column_location,
      voicemailcsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchVoicemailBox(
      this.context.user?.domain,
      "all",
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      this.state.searchFilter,
    );
    Logger("Voicemail fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchVoicemailBox(
      this.context.user?.domain,
      "all", 1, 100000,
      this.state.searchText,
      this.state.searchFilter,
    );
    return response.ok ? response.data?.data : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "voicemail_enabled") return item[column] === "true" ? "Enabled" : "Disabled";
    if (column === "voicemail_description") return `"${item[column] || ""}"`;
    return item[column];
  };

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  renderAddNewForm = () => (
    <NtModal ref={this.addModalRef}>
      <NtVoicemailNewForm
        onCancel={() => this.addModalRef.current?.dismiss()}
        onCreate={() => {
          this.setState({ page: 1 }, () => this.handleDataFetch());
          this.addModalRef.current?.dismiss();
          showToast("Success", "Successfully created the new voicemail");
        }}
      />
    </NtModal>
  );

  renderRow = (item) => (
    <NtVoicemailItemItem
      key={item.voicemail_uuid}
      item={item}
      columns={this.state.columns}
      onUpdate={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", `Successfully updated Voicemail ${item?.voicemail_id}`);
      }}
      onDelete={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", `Successfully deleted Voicemail ${item?.voicemail_id}`);
      }}
      onPress={() => this.props.navigation.navigate(routes.voicemailmessage, { extension: item.voicemail_id })}
    />
  );

  render() {
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit);
    const count = this.state.totalItems || 0;
    const subtitle = `Voicemail boxes for receiving messages · ${count} mailbox${count === 1 ? "" : "es"}`;

    const actions = canEdit ? (
      <NtPageActionButton
        icon="plus"
        title="Add Voicemail"
        variant="primary"
        onPress={() => this.addModalRef.current?.show()}
      />
    ) : null;

    const searchBar = (
      <NtSearchBar value={this.state.searchText} onChangeText={this.handleSearch} />
    );

    return (
      <NtRootPageContainer
        pageTitle="Voicemails"
        pageSubtitle={subtitle}
        permission={this.handlePermissionCheck()}
        actions={actions}
      >
        <NtPageSection
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={voicemailcsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              exportFileName="voicemail"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map(this.renderRow)}
          </View>
        </NtPageSection>

        {this.renderAddNewForm()}
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default VoicemailController;
